var $f897d5e89fafab81$exports = {};
$f897d5e89fafab81$exports = {
    "colorFormat": `\u{30AB}\u{30E9}\u{30FC}\u{30D5}\u{30A9}\u{30FC}\u{30DE}\u{30C3}\u{30C8}`,
    "hex": `16 \u{9032}\u{6570}`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$f897d5e89fafab81$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
